
import { useBodegaStore, useCategoriaProductoStore } from '@/store/erp';
import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

export type ComprasModuleProps = {};

const ComprasModule: React.FC<ComprasModuleProps> = () => {

  const getBodega = useBodegaStore(s => s.getBodega);
  const getCategoriaProducto = useCategoriaProductoStore(s => s.getCategoriaProducto);


  useEffect(()=>{
    (async () => {
      const results = await Promise.allSettled([
        getBodega({ page_size: 600 }),
        getCategoriaProducto({ page_size: 600 })
  
      ]);
      results.forEach((result, index) => {
        if (result.status === 'rejected') {
          console.error(`Compras data load failed at position ${index}:`, result.reason);
        }
      });
    })();

  }, [])

  return (
    <>
      <Outlet />
    </>
  );
};

export default ComprasModule;
